module.exports = __webpack_public_path__ + "static/img/maolun.ef6bf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/maolun.png
// module id = 0cIw
// module chunks = 0